import React, { useEffect } from "react";

export default function DICE11X() {
   useEffect(() => {
    // Inject Meta Pixel script (ESLint safe version)
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );

    // Initialize Pixel
    window.fbq("init", "674744678726322");

    // Track page view
    window.fbq("track", "PageView");

    // <noscript> fallback
    // const noscript = document.createElement("noscript");
    // const img = document.createElement("img");

    // img.height = 1;
    // img.width = 1;
    // img.style.display = "none";
    // img.src =
    //   "https://www.facebook.com/tr?id=674744678726322&ev=PageView&noscript=1";

    // noscript.appendChild(img);
    // document.body.appendChild(noscript);

    // return () => {
    //   noscript.remove();
    // };
  }, []);

  return null;
}
